// js
import React from 'react';
import PropTypes from 'prop-types';


const ConfiguredItemFormField = ({ label, children, flex }) => {
  return (
    <div
      className='configured-item-form__field'
      style={{ flex: flex || 1 }}
    >
      <label>{label}</label>
      {children}
    </div>
  );
};

ConfiguredItemFormField.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  flex: PropTypes.number
};

export default ConfiguredItemFormField;



// WEBPACK FOOTER //
// ./src/components/sources/ConfiguredItemFormField.js